import React, { useState } from "react";
import "../style/providerFilter-style.css";

const ProviderFilter = ({ filters, onFilterChange, onClearFilters }) => {
  const defaultFilters = {
    keyword: '',
    status: ''
  };

  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (e) => {
    setLocalFilters({ ...localFilters, [e.target.name]: e.target.value });
  };

  const applyFilters = () => {
    onFilterChange(localFilters);
  };

  const handleClearFilters = () => {
    setLocalFilters(defaultFilters);
    onClearFilters(defaultFilters); 
  };

  return (
    <div className="provider-filter-main">
      <div className="provider-filter">
        <h3 className="text-capitalize font-size-22 text-white font-weight-semibold mb-3 text-center">
          Providers Filter
        </h3>

        <div className="filter-group">
          <h5 className="text-white font-size-15 font-weight-medium">Search By Company Name, Email, Address</h5>
          <div className="listing_main_1 clearfix">
            <div className="space_all">
              <input
                type="text"
                className="form-control input_filter select_box"
                name="keyword"
                placeholder="Search"
                value={localFilters.keyword}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="filter-group">
          <label htmlFor="status" className="form-label text-white">Status</label>
          <select
            className="form-select"
            id="status"
            name="status"
            value={localFilters.status}
            onChange={handleChange}
          >
            <option value="">All</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div className="d-flex gap-2 mt-3">
          <button className="btn btn-primary w-100" onClick={applyFilters}>
            Apply Filters
          </button>
          <button className="btn btn-secondary w-100" onClick={handleClearFilters}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProviderFilter;
